import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as momentN from 'moment'; const moment = momentN;
import { NgbDate, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'db-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss']
})
export class DatePickerComponent implements OnInit, OnChanges {
  @Input() label: string;
  @Input() required: boolean;
  @Input() placeholder?: string;
  @Input() control ?: FormControl;
  @Input() date ?: string;
  @Input() id = '';
  @Input() name ? = '';
  minDate: any;

  @Output() dateChange = new EventEmitter();

  private OUTPUT_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss';
  private INPUT_FORMAT = 'DD/MM/YYYY';
  private _displayDate: momentN.Moment;

  get displayDate(): momentN.Moment {
      if (this.date || (this.control && this.control.value)) {
          return this._displayDate;
      }
  }
  set displayDate(val: momentN.Moment) {
      this._displayDate = val;

      const date = val.format(this.OUTPUT_FORMAT);

      if (this.control) {
          this.control.setValue(date);
      }
  }

  constructor(private config: NgbDatepickerConfig) {
    const current = new Date();

    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
  }

  ngOnInit() {
      if (!this.placeholder) {
          this.placeholder = 'Select a date';
      }
  }

  ngOnChanges(changes: SimpleChanges) {
      if (changes.date) {
          this.displayDate = moment(changes.date.currentValue, this.INPUT_FORMAT);
      } else if (changes.control) {
          this.displayDate = moment(moment(changes.control.currentValue.value), this.INPUT_FORMAT);
      }
  }

  onDateSelect(event: NgbDate) {
      const formattedDate = moment();
      formattedDate.year(event.year).month(event.month - 1).date(event.day);

      this.displayDate = formattedDate;

      this.dateChange.emit(formattedDate.format(this.OUTPUT_FORMAT));

      if (this.control) {
          this.control.markAsDirty();
      }
  }
}
